import { ComplementaryItem } from '@models/balance/ComplementaryItem'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form, Input, InputNumber } from 'antd'

type Props = SBRMFormActionProps & {}

const Create = ({ form, formProps }: Props) => {
  const { getMetadata } = useSBRMForm()

  return (
    <Form
      {...formProps}
      form={form}
      layout="vertical"
      initialValues={{
        profile: getMetadata(MetadataKey.MembershipProfileId),
        quantity: 1,
      }}
    >
      <Form.Item name="profile" hidden style={{ display: 'none' }}>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item
        name="complementaryItem"
        label={'Complementary item'}
        rules={[requiredRule()]}
      >
        <SBAsyncSelect<ComplementaryItem> entity={Entity.complementaryItem} />
      </Form.Item>

      <Form.Item name="quantity" label={'Quantity'} rules={[requiredRule()]}>
        <InputNumber mode="spinner" style={{ width: '100%' }} min={1} />
      </Form.Item>
    </Form>
  )
}

export default Create
